import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminInquiries: React.FC = () => (
  <ComingSoon
    icon="💬"
    title="문의 관리"
    features={[
      "문의 목록 조회 및 상태 필터",
      "문의 내용 상세 확인",
      "답변 작성 및 수정",
      "처리 상태 관리 (대기 · 처리중 · 완료)",
      "미처리 문의 알림 설정",
    ]}
  />
);

export default AdminInquiries;
